import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Formik } from "formik";
import axios from "axios";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  ArrowBack,
  Email,
  KeyboardArrowRight,
  Person,
  Phone,
} from "@mui/icons-material";
import { addBooking, verifyCoupon } from "../../store/actions";
import { CssTextField } from "../../components/TextField";
import { activityLineTotal, activityQtyLabel } from "../../utils";
// import { useNavigate } from 'react-router-dom';
import * as yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";

function BookNow({
  code,
  colors,
  isLoading,
  setPage,
  roomtypeId,
  dispatch,
  setPaymentData,
  isActivitiesAvailable,
  selectedActivities,
  hotelDetails,
}) {
  // const navigate = useNavigate();
  // const [mPlans, setMPlans] = useState([]);
  // const [mealPlan, setMealPlan] = useState("no_preference");
  // const [mealPlanAmount, setMealPlanAmount] = useState(0);
  const [isPartialPmt, setIsPartialPmt] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [activeCoupon, setactiveCoupon] = useState("");
  const [urlParams] = useSearchParams();
  const isMokshaBooking = urlParams.get("bookingType") === "moksha";
  const [discountAmount, setDiscountAmount] = useState(0);
  const [updatedSubtotal, setUpdatedSubtotal] = useState(0);
  const [taxesAndFees, setTaxesAndFees] = useState(0);
  const formikRef = useRef(null);
  const isGstEnabled = hotelDetails?.gst_enabled === true;
  const isRoomGstLowSlab = isGstEnabled && hotelDetails?.room_gst_low_slab === true;

  let datas = localStorage.getItem("checkingData");
  datas = JSON.parse(datas);
  let selected = localStorage.getItem("selected");
  selected = JSON.parse(selected);
  const totalActivitiesPrice = selectedActivities?.reduce(
    (total, item) => total + activityLineTotal(item, item.billedCount ?? item.count),
    0
  );
  const totalActivitiesTax = isGstEnabled
    ? (totalActivitiesPrice * 18) / 100 
    : 0;
    
  // const grandTotal = (
  //   (selected?.meal_plan?.final_razorpay_amount || (selected.meal_plan.total_price + selected.meal_plan.tax_amount)) +
  //   (selectedActivities?.length ? totalActivitiesPrice + totalActivitiesTax : 0)
  // ).toFixed(2);

  // Undiscounted line-item total. Displayed as "Sub Total" so the rows above it add up;
  // the coupon is then subtracted on its own row.
  const grossSubTotal =
    selected.meal_plan.total_price +
    (selectedActivities?.length ? totalActivitiesPrice : 0);

  // Display only, and taken straight from the API - check_availability computes it. The
  // discount is already inside selected.meal_plan.total_price, so it was invisible in the
  // breakdown while the coupon got its own row. grossSubTotal is deliberately untouched, so
  // the gateway charge and the grand total cannot move.
  const websiteDiscountAmount = Number(selected?.meal_plan?.website_discount_amount) || 0;
  const actualBeforeDiscount = Number(selected?.meal_plan?.actual_price) || 0;
  // One flag for both the sub total and the row: without an actual_price the sub total is
  // already net of the discount, so showing the deduction as well would not add up.
  const showWebsiteDiscount = websiteDiscountAmount > 0 && actualBeforeDiscount > 0;
  const subTotalBeforeDiscount = showWebsiteDiscount
    ? actualBeforeDiscount
    : selected.meal_plan.total_price;

  // Payment Gateway Charges Calculation
  const currentSubTotal = activeCoupon
    ? parseFloat(updatedSubtotal)
    : grossSubTotal;

  const currentTaxesAndFees = activeCoupon
    ? taxesAndFees + (selectedActivities?.length ? totalActivitiesTax : 0)
    : selected.meal_plan.tax_amount +
      (selectedActivities?.length ? totalActivitiesTax : 0);

  const chargeableTotal = parseFloat(
    (currentSubTotal + currentTaxesAndFees).toFixed(2)
  );

  // The pre-calculated value only fits the plain no-coupon/no-activity case, and is absent
  // on payloads restored from an older localStorage shape — fall back to computing it.
  const razorpayCharges = (
    activeCoupon || selectedActivities?.length
      ? chargeableTotal * 0.03
      : selected?.meal_plan?.razorpay_charges ?? chargeableTotal * 0.03
  ).toFixed(2);
  // Payment Gateway Charges Calculation

  const finalGrandTotalWithCharges = (
    chargeableTotal + parseFloat(razorpayCharges)
  ).toFixed(2);

  // Mirrors the backend split (add-new-booking*.ts): it halves the pre-gateway total,
  // rounds, then applies the 3% to that half alone. Dividing the grand total instead
  // drifts by a paisa against what Razorpay actually charges.
  const halfOfChargeableTotal = parseFloat((chargeableTotal / 2).toFixed(2));
  const partialPayNow = (halfOfChargeableTotal * 1.03).toFixed(2);
  // Same expression as the backend's razorpay_charges, so it equals the fee in the guest mail.
  const partialRazorpayCharges = (
    halfOfChargeableTotal * 1.03 -
    halfOfChargeableTotal
  ).toFixed(2);
  const partialBalanceDue = (chargeableTotal - halfOfChargeableTotal).toFixed(2);



  // console.log(totalActivitiesPrice);

  let start = moment.unix(datas?.checkinDate);
  let end = moment.unix(datas?.checkoutDate);
  let diff = Math.ceil(moment.duration(start.diff(end)).asDays());
  diff = Math.abs(diff);

  // const { pricing } = useSelector(({ bookingEngine: { pricing } }) => ({
  //     pricing,
  // }));

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    // fetchMealPlans();
    // eslint-disable-next-line
  }, [hotelDetails]);

  // Fetch mobile number from search session for WhatsApp bookings
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const searchId = searchParams.get("searchId");
    const bookingType = searchParams.get("bookingType");

    if (bookingType === "whatsapp" && searchId) {
      const fetchMobile = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/whatsApp-chatbot/search-session/user/${searchId}`
          );
          if (res.data?.success && res.data?.data?.mobile) {
            if (formikRef.current) {
              formikRef.current.setFieldValue("guest_mobile", res.data.data.mobile);
            }
          }
        } catch (err) {
          console.error("Failed to fetch mobile from search session:", err);
        }
      };
      fetchMobile();
    }
  }, []);

  // const fetchMealPlans = async() => {
  //     let mPlans = await dispatch(listMealPlans({ roomtypeId: roomtypeId }));
  //     if(mPlans?.length){
  //         const sortedPlans = mPlans.sort((a, b) => a.rate - b.rate);
  //         setMPlans(sortedPlans);
  //         setMealPlan(sortedPlans[0]?._id)
  //         setMealPlanAmount(sortedPlans[0]?.rate)
  //     } else {
  //         setMPlans([{
  //             _id: "no_preference",
  //             name: "CP",
  //             rate: 0,
  //         }])
  //     }
  // }

  const initialValues = {
    title: "Mr",
    name: "",
    first_name: "",
    last_name: "",
    email: "",
    guest_mobile: "",
    guest_address: "",
    remarks: "",
    buyer_pincode: "682304",
  };

  const validationSchema = yup.object().shape({
    first_name: yup
      .string()
      .matches(/^\S*$/, "Spaces not allowed")
      .matches(/^\w*$/, "Special chars not allowed")
      .required("Required"),
    last_name: yup
      .string()
      .matches(/^\S*$/, "Spaces not allowed")
      .matches(/^\w*$/, "Special chars not allowed")
      .required("Required"),
    email: yup.string().email("Invalid email").required("Required"),
    guest_mobile: yup
      .string()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(6, "Invalid mobile number")
      .max(20, "Invalid mobile number")
      // .matches(/^\d{10}$/, "Invalid mobile number")
      .required("Required"),
    // buyer_pincode: yup.number().required("Required"),
  });

  const handleRazorpayPayment = (paymentData, formValues) => {
    const { razorpayData } = paymentData;
    const options = {
      key: razorpayData.key,
      amount: razorpayData.amount,
      currency: razorpayData.currency,
      name: hotelDetails?.name || "Booking",
      description: `Booking at ${hotelDetails?.name}`,
      image: hotelDetails?.logo_url,
      order_id: razorpayData.razorpay_order_id,
      callback_url: `https://hotels.travelnet.in/booking/${code}`,
      prefill: {
        name: `${formValues.first_name} ${formValues.last_name || ""}`,
        email: formValues.email,
        contact: formValues.guest_mobile,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };
    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };

  const handleFormSubmit = async (values) => {
    const searchParams = new URLSearchParams(window.location.search);
    values.email = values?.email?.toLowerCase();
    let val = {
      ...values,
      hotel_code: code,
      roomtype_id: roomtypeId,
      no_of_adults: datas?.numOfAdults,
      no_of_childs: datas?.numOfChilds,
      total_rooms: datas?.totalRooms,
      checkin_date: datas?.checkinDate,
      checkout_date: datas?.checkoutDate,
      name: `${values.first_name} ${values.last_name || ""}`,
      meal_plan_id: selected.meal_plan._id ? selected.meal_plan._id : "",
      activities: selectedActivities?.map(({ _id, count, billedCount }) => ({
        _id,
        count: billedCount ?? count,
      })),
      partial_pmt: isPartialPmt,
      coupon_code: couponCode || "",
    };

    if (searchParams.toString()) {
      val.booking_from = "google";
    }

    // WhatsApp booking support
    const bookingType = searchParams.get("bookingType");
    const searchId = searchParams.get("searchId");
    if (bookingType === "whatsapp" && searchId) {
      val.booking_type = bookingType;
      val.search_id = searchId;
      val.booking_from = "whatsapp";
    } else if (bookingType === "moksha") {
      // Moksha partner links: ?bookingType=moksha
      val.booking_from = "moksha";
    }

    let res = await dispatch(addBooking(val, activeCoupon));
    if (res) {
      handleRazorpayPayment(res, values);
    }
  };

  const handleCouponVerify = async () => {
    try {
      if (!couponCode) {
        console.warn("Coupon code is required.");
        return;
      }

      const payload = {
        coupon_code: couponCode,
        hotel_id: hotelDetails?._id, // Ensure hotelId is available
        roomtype_id: roomtypeId,
        check_in_date: moment.unix(datas?.checkinDate).format("YYYY-MM-DD"),
        check_out_date: moment.unix(datas?.checkoutDate).format("YYYY-MM-DD"),
        selected_meal_plan: selected?.meal_plan?._id, // Pass selected meal plan ID
      };

      const response = await dispatch(verifyCoupon(payload));

      if (response?.valid) {
        toast.success("Coupon applied successfully!");
        toast.success(response?.message);
        if (!response.coupon.default_meal_plan_id) {
          toast.error("Default meal plan not found in roomtype.");
          return;
        }
        setactiveCoupon(response.coupon);

        const discountPercentage = response.coupon.discount_value || 0;

        const defaultMealPlan = selected?.meal_plan_rates?.find(
          (plan) => plan._id === response.coupon.default_meal_plan_id
        );

        if (defaultMealPlan) {
          const discountAmount =
            (defaultMealPlan.total_price * discountPercentage) / 100;
          setDiscountAmount(discountAmount);
          const totalActivitiesPrice = selectedActivities?.reduce(
            (total, item) => total + activityLineTotal(item, item.billedCount ?? item.count),
            0
          );

          const updatedSubtotal =
            (
              selected.meal_plan.total_price -
              discountAmount +
              (selectedActivities?.length ? totalActivitiesPrice : 0)
            ).toFixed(2) || "-";

           const subTotalForRoom = selected.meal_plan.total_price - discountAmount;
          // Recalculate grand total
     
          let taxPercentage = isRoomGstLowSlab
            ? 5
            : ((subTotalForRoom/diff)/datas.totalRooms) >= 7500 ? 18 : 5;
          let taxForUpdatedSubTotal = isGstEnabled
            ? (parseFloat(
                selected.meal_plan.total_price - discountAmount
              ) *
                taxPercentage) /
              100
            : 0;
          setTaxesAndFees(taxForUpdatedSubTotal);
          setUpdatedSubtotal(updatedSubtotal);
        }
      } else {
        console.warn("Coupon is invalid:", response?.message);
        toast.error(response?.message || "Invalid coupon.");
      }
    } catch (error) {
      console.error("Error verifying coupon:", error);
    }
  };

  return (
    <>
      <Stack alignItems="center">
        <Grid container spacing={2} justifyContent="center" mb={5}>
          <Grid item md={12} xs={12}>
            {/* <Button variant='contained' onClick={() => setPage(isActivitiesAvailable ? 3 : 2)}>
                            <ArrowBack />
                        </Button> */}
            <Stack
              p={2}
              bgcolor={"rgb(0, 0, 0, 0.7)"}
              style={{ backdropFilter: `blur(5px)` }}
              borderRadius={2}
              mt={2}
            >
              <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                  {selected ? (
                    <>
                      <Stack
                        bgcolor={colors.primary[400]}
                        p={1}
                        borderRadius={1}
                      >
                        <Stack p={1} spacing={1}>
                          <Stack direction="row" justifyContent="space-between">
                            <Stack width={"50%"} borderRight={"1px solid #666"}>
                              <Typography color={"#aaa"} fontSize={"small"}>
                                Check In
                              </Typography>
                              <Typography fontWeight={600}>
                                {moment
                                  .unix(datas?.checkinDate)
                                  .format("DD-MMM-YYYY") || "-"}
                              </Typography>
                            </Stack>
                            <Stack width={"50%"} textAlign="right">
                              <Typography color={"#aaa"} fontSize={"small"}>
                                Check Out
                              </Typography>
                              <Typography fontWeight={600}>
                                {moment
                                  .unix(datas?.checkoutDate)
                                  .format("DD-MMM-YYYY") || "-"}
                              </Typography>
                            </Stack>
                          </Stack>
                          <Divider />

                          <Stack direction="row" justifyContent="space-between">
                            <Typography color={"#aaa"} fontSize={"small"}>
                              No of nights
                            </Typography>
                            <Typography fontWeight={600}>
                              {diff ?? "0"} {diff === 1 ? "Night" : "Nights"}
                            </Typography>
                          </Stack>
                          <Stack direction="row" justifyContent="space-between">
                            <Typography color={"#aaa"} fontSize={"small"}>
                              Room
                            </Typography>
                            <Typography fontWeight={600}>
                              {`${datas?.totalRooms} x ${selected.name}` || "-"}
                            </Typography>
                          </Stack>
                          <Stack direction="row" justifyContent="space-between">
                            <Typography color={"#aaa"} fontSize={"small"}>
                              Guests
                            </Typography>
                            <Typography fontWeight={600}>
                              {datas?.numOfAdults ?? 0} Adults,{" "}
                              {datas?.numOfChilds ?? 0} Children
                            </Typography>
                          </Stack>
                        </Stack>

                        <Stack p={1} spacing={1} border={"1px solid #666"}>
                          <Stack direction="row" alignItems="center">
                            <KeyboardArrowRight color="primary" />{" "}
                            <Typography
                              color={"#aaa"}
                              flexGrow={1}
                              fontSize={"small"}
                            >
                              {selected?.meal_plan?.name}{" "}
                              {selected?.meal_plan?.description
                                ? `- ${selected?.meal_plan?.description}`
                                : ""}
                            </Typography>
                            {/* Net of tax and gateway fee — both are itemised further down. */}
                            <Typography fontWeight={600}>
                              ₹{selected.meal_plan.total_price.toFixed(2) || "-"}
                            </Typography>
                          </Stack>
                          {selectedActivities?.length ? (
                            <Stack>
                              <Stack direction="row">
                                <KeyboardArrowRight color="primary" />
                                <Typography
                                  color={"#aaa"}
                                  flexGrow={1}
                                  fontSize={"small"}
                                >
                                  Enhance Your Stay
                                </Typography>
                              </Stack>
                              {selectedActivities.map((activity) => {
                                const qty =
                                  activity.billedCount ?? activity.count;
                                return (
                                  <Stack
                                    key={activity._id}
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="end"
                                    spacing={1}
                                    pl={3}
                                    mt={0.5}
                                  >
                                    <Stack>
                                      <Typography fontSize={"small"}>
                                        {activity.name}
                                      </Typography>
                                      <Typography color={"#aaa"} fontSize={12}>
                                        ₹
                                        {parseFloat(activity.rate || 0).toFixed(
                                          2
                                        )}{" "}
                                        x {activityQtyLabel(activity, qty)}
                                      </Typography>
                                    </Stack>
                                    <Typography fontWeight={600}>
                                      ₹
                                      {activityLineTotal(activity, qty).toFixed(
                                        2
                                      )}
                                    </Typography>
                                  </Stack>
                                );
                              })}
                            </Stack>
                          ) : null}
                          {!isMokshaBooking && (
                          <Stack spacing={2} mt={2} mb={1}>
                            <Typography color={"#aaa"} fontSize={"small"}>
                              Have a Coupon?
                            </Typography>
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                            >
                              <TextField
                                label="Coupon Code"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setCouponCode(e.target.value)}
                                fullWidth
                                inputProps={{
                                  maxLength: 9,
                                }}
                              />
                              <Button
                                variant="contained"
                                color="primary"
                                disabled={couponCode.length !== 9}
                                onClick={handleCouponVerify}
                              >
                                Verify
                              </Button>
                            </Stack>
                          </Stack>
                          )}
                          <Divider />
                          <Stack direction="row" justifyContent="space-between">
                            <Typography color={"#aaa"} fontSize={"small"}>
                              Sub Total
                            </Typography>
                            <Typography fontWeight={600}>
                              ₹
                              {(
                                subTotalBeforeDiscount +
                                (selectedActivities?.length ? totalActivitiesPrice : 0)
                              ).toFixed(2) || "-"}
                            </Typography>
                          </Stack>
                          {showWebsiteDiscount ? (
                            <Stack direction="row" justifyContent="space-between">
                              <Typography color={"#aaa"} fontSize={"small"}>
                                Website discount
                              </Typography>
                              <Typography fontWeight={600} color="#7ed09b">
                                −₹{websiteDiscountAmount.toFixed(2)}
                              </Typography>
                            </Stack>
                          ) : null}
                          {activeCoupon ? (
                            <Stack direction="row" justifyContent="space-between">
                              <Typography color={"#aaa"} fontSize={"small"}>
                                Coupon ({couponCode})
                              </Typography>
                              <Typography fontWeight={600} color="#7ed09b">
                                −₹{discountAmount.toFixed(2)}
                              </Typography>
                            </Stack>
                          ) : null}
                          <Stack direction="row" justifyContent="space-between">
                            <Typography color={"#aaa"} fontSize={"small"}>
                              GST
                            </Typography>
                            <Typography fontWeight={600}>
                              ₹{currentTaxesAndFees.toFixed(2) || "-"}
                            </Typography>
                          </Stack>
                          {isPartialPmt ? (
                            <>
                              <Stack direction="row" justifyContent="space-between">
                                <Typography color={"#aaa"} fontSize={"small"}>
                                  Booking total
                                </Typography>
                                <Typography fontWeight={600}>
                                  ₹{chargeableTotal.toFixed(2)}
                                </Typography>
                              </Stack>
                              <Divider />
                              <Stack direction="row" justifyContent="space-between">
                                <Typography color={"#aaa"} fontSize={"small"}>
                                  Pay now (50%)
                                </Typography>
                                <Typography fontWeight={600}>
                                  ₹{halfOfChargeableTotal.toFixed(2)}
                                </Typography>
                              </Stack>
                              <Stack direction="row" justifyContent="space-between">
                                <Typography color={"#aaa"} fontSize={"small"}>
                                  Online payment fee (3%)
                                </Typography>
                                <Typography fontWeight={600}>
                                  ₹{partialRazorpayCharges}
                                </Typography>
                              </Stack>
                              <Divider />
                              <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="end"
                              >
                                <Typography>Total payable now</Typography>
                                <Typography
                                  color="primary"
                                  fontSize="20px"
                                  fontWeight={600}
                                >
                                  ₹{partialPayNow}
                                </Typography>
                              </Stack>
                              <Stack direction="row" justifyContent="space-between">
                                <Typography color={"#aaa"} fontSize={"small"}>
                                  Balance at property
                                </Typography>
                                <Typography fontWeight={600}>
                                  ₹{partialBalanceDue}
                                </Typography>
                              </Stack>
                            </>
                          ) : (
                            <>
                              <Stack direction="row" justifyContent="space-between">
                                <Typography color={"#aaa"} fontSize={"small"}>
                                  Online payment processing (3%)
                                </Typography>
                                <Typography fontWeight={600}>
                                  ₹{razorpayCharges || "-"}
                                </Typography>
                              </Stack>
                              <Divider />
                              <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="end"
                              >
                                <Typography>Grand Total</Typography>
                                <Typography
                                  color="primary"
                                  fontSize="20px"
                                  fontWeight={600}
                                >
                                  ₹{finalGrandTotalWithCharges || "-"}
                                </Typography>
                              </Stack>
                            </>
                          )}
                        </Stack>
                      </Stack>
                    </>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={8}>
                  <Formik
                    innerRef={formikRef}
                    onSubmit={handleFormSubmit}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    enableReinitialize={false}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleBlur,
                      handleChange,
                      handleSubmit,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <Grid container spacing={3}>
                          <Grid item md={6} xs={12}>
                            <Stack direction="row">
                              <CssTextField
                                select
                                required
                                name="title"
                                onChange={handleChange}
                                value={values.title}
                                sx={{ width: 100 }}
                              >
                                <MenuItem value={"Mr"}>{"Mr"}</MenuItem>
                                <MenuItem value={"Ms"}>{"Ms"}</MenuItem>
                              </CssTextField>
                              <CssTextField
                                required
                                fullWidth
                                // size="small"
                                type="text"
                                // label="Name"
                                placeholder="Fist name *"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.first_name}
                                name="first_name"
                                error={
                                  !!touched.first_name && !!errors.first_name
                                }
                                helperText={
                                  touched.first_name && errors.first_name
                                }
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Person />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Stack>
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <CssTextField
                              required
                              fullWidth
                              // size="small"
                              type="text"
                              // label="Name"
                              placeholder="Last name *"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.last_name}
                              name="last_name"
                              error={!!touched.last_name && !!errors.last_name}
                              helperText={touched.last_name && errors.last_name}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Person />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <CssTextField
                              required
                              fullWidth
                              // size="small"
                              type="email"
                              // label="Email"
                              placeholder="Email *"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.email}
                              name="email"
                              error={!!touched.email && !!errors.email}
                              helperText={touched.email && errors.email}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Email />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <CssTextField
                              required
                              fullWidth
                              // size="small"
                              type="number"
                              placeholder="Mobile *"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.guest_mobile}
                              name="guest_mobile"
                              error={
                                !!touched.guest_mobile && !!errors.guest_mobile
                              }
                              helperText={
                                touched.guest_mobile && errors.guest_mobile
                              }
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Phone />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          {/* <Grid item md={6} xs={12}>
                                                <CssTextField
                                                    fullWidth
                                                    // size="small"
                                                    type="number"
                                                    label="Paid Amount"
                                                    placeholder="Paid Amount"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.paidAmount}
                                                    name="paidAmount"
                                                    onInvalid={e => e.target.setCustomValidity(rateErrorMsg)}
                                                    onInput={e => e.target.setCustomValidity('')}
                                                    error={!!touched.paidAmount && !!errors.paidAmount}
                                                    helperText={touched.paidAmount && errors.paidAmount}
                                                    InputProps={{
                                                        inputProps: { min: 0, max: selectedRooms[0]?.rate },
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Money />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid> */}
                          {/* <Grid item md={6} xs={12}>
                                                <CssTextField
                                                    fullWidth
                                                    select
                                                    // size="small"
                                                    value={status}
                                                    label="Status"
                                                    onChange={(e) => setStatus(e.target.value)}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Build />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                >
                                                    <MenuItem value={"confirmed"}>
                                                        {"Confirmed"}
                                                    </MenuItem>
                                                    <MenuItem value={"hold"}>
                                                        {"Hold"}
                                                    </MenuItem>
                                                </CssTextField>
                                            </Grid> */}

                          {/* <Grid item md={6} xs={12}>
                                                <CssTextField
                                                    fullWidth
                                                    select
                                                    // size="small"
                                                    value={mealPlan}
                                                    label="Meal Plan"
                                                    onChange={(e) => {
                                                        setMealPlan(e.target.value)
                                                        setMealPlanAmount(mPlans.find((el) => el._id === e.target.value).rate)
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Restaurant />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                >
                                                    {!mPlans?.length ?
                                                        <MenuItem value={"no_preference"}>
                                                            {"CP"}
                                                        </MenuItem>
                                                        : null}
                                                    {mPlans?.map((e) => (
                                                        <MenuItem value={e?._id} key={e?._id}>
                                                            <Stack width="100%">
                                                                <Stack
                                                                    width="100%"
                                                                    direction="row"
                                                                    justifyContent="space-between"
                                                                    spacing={2}
                                                                >
                                                                    <Typography>
                                                                        {e?.name?.toUpperCase()}
                                                                    </Typography>
                                                                    <Typography>
                                                                        ₹{e?.rate}
                                                                    </Typography>
                                                                </Stack>
                                                                <Typography color={"#aaa"}><small>{e?.description}</small></Typography>
                                                            </Stack>
                                                        </MenuItem>
                                                    ))}
                                                </CssTextField>
                                                <Stack alignItems="end">
                                                    <Typography fontSize="small">/ person</Typography>
                                                </Stack>
                                            </Grid> */}
                          {/* <Grid item md={6} xs={12}>
                                                <Typography fontSize="small" mt={-2}>Meal plan</Typography>
                                                <Grid container spacing={1}>
                                                    {mPlans?.map((plan) => (
                                                        <Grid item key={plan._id}>
                                                            <Box
                                                                p={1}
                                                                borderRadius={1}
                                                                border={plan._id === mealPlan ? `1px solid ${colors.greenAccent[400]}` : "1px solid #999"}
                                                                bgcolor={plan._id === mealPlan ? colors.greenAccent[700] : ""}
                                                                sx={{ cursor: "pointer" }}
                                                                onClick={() => {
                                                                    setMealPlan(plan._id)
                                                                    setMealPlanAmount(mPlans.find((el) => el._id === plan._id).rate)
                                                                }}
                                                            >
                                                                <Typography>
                                                                    {plan?.name?.toUpperCase()} = Rs {plan?.rate}
                                                                </Typography>
                                                                {plan?.description ? (
                                                                <Typography color={"#aaa"}><small>{plan?.description}</small></Typography>
                                                                ) : null}
                                                            </Box>
                                                        </Grid>
                                                    ))}
                                                    <Grid item><Typography fontSize="small">/ person</Typography></Grid>
                                                </Grid>
                                            </Grid> */}
                          {/* <Grid item md={6} xs={12}>
                                                <CssTextField
                                                    required
                                                    fullWidth
                                                    // size="small"
                                                    type="number"
                                                    placeholder="Pincode *"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.buyer_pincode}
                                                    name="buyer_pincode"
                                                    error={!!touched.buyer_pincode && !!errors.buyer_pincode}
                                                    helperText={touched.buyer_pincode && errors.buyer_pincode}
                                                // InputProps={{
                                                //     startAdornment: (
                                                //         <InputAdornment position="start">
                                                //             <Phone />
                                                //         </InputAdornment>
                                                //     ),
                                                // }}
                                                />
                                            </Grid> */}

                          {/* <Grid item md={6} xs={12}>
                                                <CssTextField
                                                    fullWidth
                                                    multiline
                                                    minRows={3}
                                                    maxRows={Infinity}
                                                    type="text"
                                                    size="small"
                                                    label="Address"
                                                    placeholder="Address"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.guest_address}
                                                    name="guest_address"
                                                    error={!!touched.guest_address && !!errors.guest_address}
                                                    helperText={touched.guest_address && errors.guestAddress}
                                                // InputProps={{
                                                //     startAdornment: (
                                                //         <InputAdornment position="start">
                                                //             <EditLocation />
                                                //         </InputAdornment>
                                                //     ),
                                                // }}
                                                />
                                            </Grid> */}
                          <Grid item md={6} xs={12}>
                            <CssTextField
                              fullWidth
                              multiline
                              minRows={3}
                              maxRows={Infinity}
                              type="text"
                              size="small"
                              label="Remarks"
                              placeholder="Remarks"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.remarks}
                              name="remarks"
                              error={!!touched.remarks && !!errors.remarks}
                              helperText={touched.remarks && errors.remarks}
                              // InputProps={{
                              //     startAdornment: (
                              //         <InputAdornment position="start">
                              //             <NoteAdd />
                              //         </InputAdornment>
                              //     ),
                              // }}
                            />
                          </Grid>
                          {/* <Grid item xs={12}>
                                                    <Typography color="primary" fontSize="20px" textAlign="right">
                                                        Total Price: <b>₹{pricing?.total_price + (datas?.numOfAdults * mealPlanAmount)}</b>
                                                    </Typography>
                                                    <Typography color="#ccc" textAlign="right">
                                                        (including tax)
                                                    </Typography>
                                            </Grid> */}
                          {hotelDetails?.bke_partial_pmt === true ? (
                            <Grid item md={12} xs={12}>
                              <Stack
                                pl={1}
                                pr={1}
                                spacing={1}
                                border={"1px solid #666"}
                              >
                                <RadioGroup
                                  value={isPartialPmt.toString()}
                                  onChange={(e) => setIsPartialPmt(e.target.value === "true")}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                  >
                                    <FormControlLabel
                                      value={true}
                                      control={<Radio />}
                                      label="Pay 50% now"
                                    />
                                    <Stack textAlign="right">
                                      <Typography
                                        color="primary"
                                        fontSize="20px"
                                        fontWeight={600}
                                      >
                                        ₹{partialPayNow || "-"}
                                      </Typography>
                                      <Typography color={"#aaa"} fontSize={12}>
                                        ₹{partialBalanceDue} due at check-in
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                  <Divider />
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                  >
                                    <FormControlLabel
                                      value={false}
                                      control={<Radio />}
                                      label="Pay in full now"
                                    />
                                    <Stack textAlign="right">
                                      <Typography
                                        color="primary"
                                        fontSize="20px"
                                        fontWeight={600}
                                      >
                                        ₹{finalGrandTotalWithCharges || "-"}
                                      </Typography>
                                      <Typography color={"#aaa"} fontSize={12}>
                                        Nothing due at check-in
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                </RadioGroup>
                              </Stack>
                            </Grid>
                          ) : null}
                        </Grid>
                        <Grid container spacing={2} mt={6}>
                          {/* <Grid item md={6} xs={12}>
                                                <Button
                                                    fullWidth
                                                    // size="small"
                                                    color="secondary"
                                                    variant="outlined"
                                                    sx={{ fontSize: "15px" }}
                                                    onClick={() => setPage(2)}
                                                >
                                                    <b>Go Back</b>
                                                </Button>
                                            </Grid> */}
                          <Grid item md={12} xs={12}>
                            <Button
                              fullWidth
                              // size="small"
                              type="submit"
                              color="secondary"
                              variant="contained"
                              sx={{ fontSize: "15px" }}
                            >
                              {isLoading ? (
                                <CircularProgress color="inherit" size={24} />
                              ) : (
                                <b>
                                  Pay ₹
                                  {isPartialPmt
                                    ? partialPayNow
                                    : finalGrandTotalWithCharges}
                                </b>
                              )}
                            </Button>
                          </Grid>
                        </Grid>
                      </form>
                    )}
                  </Formik>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
}

export default BookNow;
